import { createFileRoute } from "@tanstack/react-router";
import { AssetsCleanupTab } from "@/components/AssetsCleanup";
import { PageHeader } from "@/components/PageHeader";

function RouteComponent() {
  return (
    <div className="space-y-4">
      <PageHeader title="Assets Cleanup" subtitle="Review and edit assets for all deals." />
      <AssetsCleanupTab />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/assets-cleanup/")({
  component: RouteComponent,
  staticData: { page: "valuations" },
});
